import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SecondaryOtpService } from './secondary-otp.service';
import { OtpModalService } from './otp-modal.service';
import { environment } from 'src/environments/environment';

export const secondaryOtpGuard: CanActivateFn = async () => {
  if (!environment?.settings?.secondaryOtpEnabled) {
    return true;
  }
  const otpService = inject(SecondaryOtpService);
  const modalService = inject(OtpModalService);

  if (otpService.isOtpVerified) {
    return true;
  }

  const verified = await modalService.openOtpModal();
  return verified;
};
